import { defineComponent } from 'vue'

import { getTranslatedString, ThesaurusTerm } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

interface Option {
    text: string;
    value: string;
}

export const ThesaurusTermSelectField = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        id: { type: String, required: true },
        placeholder: { type: String },
    },
    template: require('./thesaurus-term-select-field.html'),
    data() {
        return {
            thesaurusTerms: null as any as ThesaurusTerm[],
            options: null as any as Option[],
        }
    },
    mounted() {
        this.subscribeToThesaurusTerm();
    },
    beforeUnmount() {
        this.unsubscribeFrom('thesaurusTerm');
    },
    methods: {
        subscribeToThesaurusTerm() {
            this.subscribeTo(
                this.$thesaurusTermDataStore.fetchChildren(this.id, this.getAppLocale()),
                thesaurusTerms => {
                    this.thesaurusTerms = thesaurusTerms;
                },
                'thesaurusTerm',
            );
        },
    },
    watch: {
        id() {
            this.unsubscribeFrom('thesaurusTerm');
            this.subscribeToThesaurusTerm();
        },
        thesaurusTerms: {
            handler() {
                this.options = this.thesaurusTerms.map(thesaurusTerm => ({
                    text: getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), this.getAppLocale()),
                    value: thesaurusTerm.id,
                }));

                this.options.unshift({
                    text: this.placeholder ?? '',
                    value: null as any,
                });
            },
            deep: true,
        },
    },
})
